// import { BadgeBg } from 'components/base/Badge';
import { PageBreadcrumbItem } from 'components/common/PageBreadcrumb';
import memberService from 'services/member';
export const memberBreadcrumbItems: PageBreadcrumbItem[] = [
  {
    label: 'Admin',
    url: '#!'
  },
  {
    label: 'Members',
    active: true
  }
];

export type Member = {
  firstName: string;
  lastName: string;
  avatar?: string;
  privacyPolicy: string;
  termsOfService: string;
  dateOfBirth: string | null;
  bio: string | null;
  company: string | null;
  jobTitle: string | null;
  country: string | null;
  state: string | null;
  city: string | null;
  zipCode: string | null;
  address: string | null;
  address2: string | null;
  phone: string | null;
  website: string | null;
  facebook: string | null;
  twitter: string | null;
  instagram: string | null;
  linkedIn: string | null;
  youTube: string | null;
  vimeo: string | null;
  pinterest: string | null;
  topic1WhatsNew: boolean;
  topic2Recommendations: boolean;
  topic3PitchCompetitions: boolean;
  topic4PitchChallenges: boolean;
  topic5AcheivementsMilestones: boolean;
  topic6SpecialEvents: boolean;
  messageFrequency: number;
  messageMethod: number;
  marketing: number;
  templates: boolean;
  reportsToId: string | null;
  reportsTo: string | null;
  subordinates: string | null;
  notifications: string | null;
  subscriptions: string | null;
  paymentMethods: string | null;
  dateCreated: string;
  dateModified: string;
  dateDeleted: string;
  custom: string | null;
  id: string;
  userName: string;
  normalizedUserName: string;
  email: string;
  normalizedEmail: string;
  emailConfirmed: boolean;
  passwordHash: string;
  securityStamp: string;
  concurrencyStamp: string;
  phoneNumber: string | null;
  phoneNumberConfirmed: boolean;
  twoFactorEnabled: boolean;
  lockoutEnd: string | null;
  lockoutEnabled: boolean;
  accessFailedCount: number;
};

export let members: Member[] = [];

export async function fetchMembers() {
  try {
    members = await memberService.getAllMembers();
  } catch (error) {
    console.error('Error fetching members:', error);
  }
}
